(function (window, document) {
  'use strict';
  if (window.BYPConsentGate) return;

  var loader = document.currentScript;
  var previewThemeId = loader && loader.dataset.previewThemeId;
  var clarityId = loader && loader.dataset.clarityId;
  var customerPrivacy = null;
  var affirmRequested = false;
  var clarityRequested = false;
  var state = { region: '', status: 'blocked', consent: '', reason: 'initializing', source: 'shopify' };
  var previewAccepted = false;

  function copyState() { return { region: state.region, status: state.status, consent: state.consent, reason: state.reason, source: state.source }; }
  function region(value) { return String(value || '').replace(/[^a-z]/gi, '').toUpperCase(); }
  function explicitConsent(api) {
    if (!api || typeof api.currentVisitorConsent !== 'function') return '';
    var value = String((api.currentVisitorConsent() || {}).marketing || '').toLowerCase();
    if (value === 'yes' || value === 'true' || value === 'granted' || value === '1') return 'yes';
    if (value === 'no' || value === 'false' || value === 'denied' || value === '0') return 'no';
    return '';
  }
  function overrides() {
    var theme = window.Shopify && window.Shopify.theme;
    if (!theme || theme.role !== 'unpublished' || (previewThemeId && String(theme.id) !== String(previewThemeId))) return null;
    var params = new URLSearchParams(window.location.search);
    var r = region(params.get('byp_region'));
    var c = String(params.get('byp_consent') || '').toLowerCase();
    if (previewAccepted) c = 'granted';
    if (!r && c !== 'granted' && c !== 'denied') return null;
    return { region: r, consent: c };
  }
  function publish(next) {
    state = next;
    var root = document.documentElement;
    root.dataset.bypConsentRegion = state.region || 'unknown';
    root.dataset.bypConsentStatus = state.status;
    root.dataset.bypConsentValue = state.consent || 'unset';
    root.dataset.bypConsentReason = state.reason;
    root.dataset.bypConsentSource = state.source;
    document.dispatchEvent(new CustomEvent('byp:consent-state-changed', { detail: copyState() }));
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'privacy_api_ready', shopify_consent: copyState() });
    if (state.status === 'allowed') { loadAffirm(); loadClarity(); }
  }
  function evaluate() {
    var o = overrides();
    var r = o && o.region ? o.region : region(customerPrivacy && customerPrivacy.getRegion && customerPrivacy.getRegion());
    var c = o ? (o.consent === 'granted' ? 'yes' : o.consent === 'denied' ? 'no' : '') : explicitConsent(customerPrivacy);
    var source = o ? 'preview' : 'shopify';
    if (!r) return publish({ region: '', status: 'blocked', consent: c, reason: 'region_unavailable', source: source });
    if (r !== 'USCA') return publish({ region: r, status: 'allowed', consent: c, reason: 'outside_california', source: source });
    if (c === 'yes') return publish({ region: r, status: 'allowed', consent: c, reason: 'california_consent_granted', source: source });
    publish({ region: r, status: 'blocked', consent: c, reason: c === 'no' ? 'california_consent_denied' : 'california_consent_required', source: source });
  }
  function refreshAffirm() {
    if (window.affirm && window.affirm.ui && typeof window.affirm.ui.ready === 'function') {
      window.affirm.ui.ready(function () { if (window.affirm && window.affirm.ui && typeof window.affirm.ui.refresh === 'function') window.affirm.ui.refresh(); });
    }
  }
  function loadAffirm() {
    if (affirmRequested || state.status !== 'allowed') return;
    var existing = document.querySelector('script[src*="cdn1.affirm.com/js/v2/affirm.js"], script[data-byp-affirm-sdk]');
    if (existing) { affirmRequested = true; refreshAffirm(); return; }
    affirmRequested = true;
    var config = { public_api_key: (window.Shopify && window.Shopify.country === 'CA') ? 'NHE9TAZLNJ4OQFSG' : 'NHE9TAZLNJ4OQFSG', script: 'https://cdn1.affirm.com/js/v2/affirm.js', locale: 'en_US', country_code: 'USA' };
    if (window.Shopify && window.Shopify.country === 'CA') { config.country_code = 'CAN'; config.locale = ((window.Shopify.locale || 'en') === 'fr' ? 'fr' : 'en') + '_CA'; }
    window._affirm_config = config;
    var b = window.affirm || {};
    b._ = b._ || [];
    b.ui = b.ui || {}; b.checkout = b.checkout || {};
    var methods = 'set add save post open empty reset on off trigger ready setProduct'.split(' ');
    methods.forEach(function (name) { b.checkout[name] = function () { b.checkout._ = b.checkout._ || []; b.checkout._.push([name, arguments]); }; });
    b.ui.ready = function () { b.ui._ = b.ui._ || []; b.ui._.push(['ready', arguments]); };
    window.affirm = b;
    var script = document.createElement('script'); script.async = true; script.src = config.script; script.dataset.bypAffirmSdk = '';
    script.onload = function () { document.documentElement.dataset.bypAffirmStatus = 'loaded'; refreshAffirm(); };
    script.onerror = function () { affirmRequested = false; document.documentElement.dataset.bypAffirmStatus = 'error'; };
    document.head.appendChild(script); document.documentElement.dataset.bypAffirmStatus = 'requested';
  }
  function loadClarity() {
    if (clarityRequested || !clarityId || state.status !== 'allowed') return;
    clarityRequested = true;
    window.clarity = window.clarity || function () { (window.clarity.q = window.clarity.q || []).push(arguments); };
    var script = document.createElement('script'); script.async = true; script.src = 'https://www.clarity.ms/tag/' + encodeURIComponent(clarityId) + '?ref=shopify'; script.dataset.bypClaritySdk = '';
    script.onload = function () { document.documentElement.dataset.bypClarityStatus = 'loaded'; };
    script.onerror = function () { clarityRequested = false; document.documentElement.dataset.bypClarityStatus = 'error'; };
    document.head.appendChild(script); document.documentElement.dataset.bypClarityStatus = 'requested';
  }
  function initialize() {
    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return publish({ region: '', status: 'blocked', consent: '', reason: 'privacy_api_unavailable', source: 'shopify' });
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
      if (error || !window.Shopify.customerPrivacy) return publish({ region: '', status: 'blocked', consent: '', reason: 'privacy_api_unavailable', source: 'shopify' });
      customerPrivacy = window.Shopify.customerPrivacy; evaluate(); document.addEventListener('visitorConsentCollected', evaluate);
    });
  }
  window.BYPConsentGate = { getState: copyState, isAllowed: function () { return state.status === 'allowed'; }, refresh: evaluate, accept: function () { if (!customerPrivacy || typeof customerPrivacy.setTrackingConsent !== 'function') return false; customerPrivacy.setTrackingConsent({ analytics: true, marketing: true, preferences: true }, evaluate); return true; } };
  window.__gorillaConsent = { get region() { return state.region; }, get marketingAllowed() { return state.status === 'allowed'; }, get analyticsProcessingAllowed() { return state.status === 'allowed'; }, get status() { return state.status; } };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true }); else initialize();
})(window, document);
